import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18.83 10.146c.19.2.19.51 0 .71l-6 6c-.2.2-.51.2-.71 0s-.2-.51 0-.71l5.15-5.15H1.48c-.28 0-.5-.23-.5-.5s.22-.5.5-.5h15.79l-5.15-5.14c-.2-.2-.2-.51 0-.71s.51-.2.71 0l6 6z',
  ],
  height: 20,
  width: 20,
});
